module.exports = __webpack_public_path__ + "static/media/holiday-gift-card-mb-en.85e80db3.jpg";